export function subscribeToRouteChanges(onRouteChange: VoidFunction) {
  let lastUrl = window.location.href;

  const notifyIfChanged = () => {
    const nextUrl = window.location.href;
    if (nextUrl === lastUrl) return;
    lastUrl = nextUrl;
    onRouteChange();
  };

  const pushState = history.pushState.bind(history);
  const replaceState = history.replaceState.bind(history);

  history.pushState = (...args) => {
    pushState(...args);
    notifyIfChanged();
  };

  history.replaceState = (...args) => {
    replaceState(...args);
    notifyIfChanged();
  };

  window.addEventListener("popstate", notifyIfChanged);
  window.addEventListener("hashchange", notifyIfChanged);

  return () => {
    window.removeEventListener("popstate", notifyIfChanged);
    window.removeEventListener("hashchange", notifyIfChanged);
    history.pushState = pushState;
    history.replaceState = replaceState;
  };
}
